// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"1366ec88","745":"6c21d4c8"}[chunkId] + ".chunk.css";
};